import styles from "./StockStampLink.module.scss";
import { FC, ReactNode } from "react";
import Link from "next/link";
import { useAtomValue } from "jotai";
import { borderColorState, newbackgroundColorState, themeState } from "@/lib/store";
import { Card } from "@mui/material";
import SmallObfuscationBanner from "../obfuscation/SmallObfuscationBanner";

const StockStampLink: FC<{ link?: string; obfuscated: boolean; children?: ReactNode }> = ({ children, link, obfuscated }) => {
    const theme = useAtomValue(themeState);
    const backgroundColor = useAtomValue(newbackgroundColorState);
    const borderColor = useAtomValue(borderColorState);

    return (
        <>
            <style jsx global>{`
                .${styles.StockStampLink} > div * .stamp-content {
                    filter: ${obfuscated ? "blur(5px)" : "unset"};
                }
            `}</style>
            {obfuscated || !link ? (
                <div className={styles.StockStampLink}>
                    <Card sx={{ backgroundColor: backgroundColor, border: "1px solid rgba(0, 0, 0, 0.12)", borderColor: borderColor, position: "relative" }}>
                        {children}
                        {obfuscated && <SmallObfuscationBanner />}
                    </Card>
                </div>
            ) : (
                <div className={styles.StockStampLink}>
                    <Link passHref legacyBehavior href={link}>
                        {/* The card is the stamp's link: focusable, opened with Enter (Link's click handler). */}
                        <Card
                            role="link"
                            tabIndex={0}
                            onKeyDown={(e) => e.key === "Enter" && e.target === e.currentTarget && e.currentTarget.click()}
                            sx={{ backgroundColor: backgroundColor, border: "1px solid rgba(0, 0, 0, 0.12)", borderColor: borderColor, position: "relative", cursor: "pointer" }}
                        >
                            {children}
                            {obfuscated && <SmallObfuscationBanner />}
                        </Card>
                    </Link>
                </div>
            )}
        </>
    );
};

export default StockStampLink;
